import styled from 'styled-components';
import {
    infoColor,
    grayColor,
  } from "~/components/layout/Variables";


export const ContainerCard = styled.div`
  margin-top: 0rem;
`;

export const TitlePage = styled.h1`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 2rem;
  font-weight: 200;
  margin-bottom: -0.7rem;
  display: flex;
  justify-content: space-between;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  img {
    @media (max-width: 770px) {
      margin-right: 1rem;
    }
  }

`;

export const CloseIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 28px;
    height: 28px;
    margin-top: 19px;
  }

  @media (max-width: 770px) {
    margin-left: 0.5rem;
  }
`;

export const PrintIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 6%;
    height: 6%;
  }
`;

export const Title = styled.h2`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${() => grayColor};
  display: flex;
  justify-content: space-between;

  @media(min-width: 768px) {
    font-size: 1.2rem;
    margin: 1rem 0 0 0;
    display: flex;
    align-items: center;
  }
`;


export const Product = styled.span`
  color: ${() => infoColor};
  display: flex;
  justify-content: left;
`;

export const SubTitle = styled.p`
  font-size: .95rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;


export const TextQuantityHeader = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin-left: 1rem;
`;

export const TextQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;

  @media (max-width: 770px) {
    margin-left: 0.5rem;
  }
`;


export const LeftItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }
`;

export const LeftItemQuantityDesktop = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    display: None
  }
`;

export const LeftItemQuantityMobile = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (min-width: 700px) {
    display: None
  }
`;

export const LeftItemReplacementDesk = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    display: None
  }
`;

export const LeftItemReplacementMobile = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (min-width: 700px) {
    display: None
  }
`;

export const LeftItemSubdisizedDesk = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    display: None
  }
`;

export const LeftItemSubdisizedMobile = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (min-width: 700px) {
    display: None
  }
`;

export const LeftItemQuantityTotalDesktop = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  color: #fff;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    display: None
  }
`;

export const LeftItemQuantityTotalMobile = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  color: #fff;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (min-width: 700px) {
    display: None
  }
`;

export const CenterItemQuantityDesktop = styled.p`
  width: 100%;
  text-align: center;
  font-size: .95rem;
  color: ${() => grayColor};
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    text-align: center;
  }

  @media (max-width: 770px) {
    display: None
  }
`;

export const CenterItemQuantityMobile = styled.p`
  width: 100%;
  text-align: center;
  font-size: .95rem;
  color: ${() => grayColor};
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    text-align: center;
  }

  @media (min-width: 770px) {
    display: None
  }
`;

export const RightItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: right;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    text-align: right;
  }
`;

export const RightItemQuantityTotal = styled(SubTitle)`
  width: 100%;
  text-align: right;
  color: #fff;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    text-align: right;
  }
`;


export const CenterHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  padding-top: 0.1rem;
  margin: 0rem 0rem 0rem !important;

  @media (max-width: 770px) {
    margin: 0rem !important;
  }

  @media (max-width: 700px) {
    text-align: center;
  }
`;

export const ColAppliedHeaderQuantity = styled.div`
  text-align: center;
  margin: 1rem 0rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0rem .5rem 0rem;
  }
`;

export const Select = styled.button`
  width: ${(props) => (props.width ? props.width : `100%`)};
  font-size: 1.2rem;
  border: 0.6px solid rgba(80, 80, 80, 0.3);
  background-color: #fff;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 0.4rem;
  padding: 0.2rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${(props) => props.margin};
`;


export const Align= styled.div`
  display: grid;
  grid-template-columns: 15% 65% 20%;

  .product {
    margin: .5rem .5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .align-icon {
    margin: .5rem;
  }
`;

export const AlignDropdownBranch = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: '9px'
};

export const ButtonDivision = styled.div`
  width: 50%;
  margin: 2.5rem auto 1.5rem auto;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const CardInput = styled.div`
  margin-top: 0rem;
`;

export const CardInputItem = styled.div`
  margin: 0.5rem 1rem 0rem;
`;


export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderRadius: ".2rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxShadow: '0px 2px 4px #00000033',
  marginBottom: "1rem"
};

export const CardHeaderTotal = {
  backgroundColor: "#777",
  color: "#fff",
  fontSize: ".95rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderRadius: ".2rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxShadow: '0px 2px 4px #00000033'
};

export const InputApply = styled.input`
  font-size: 1.1rem;
  text-align: left;
  padding: 0.2rem 1rem;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  width: 100%;
`;


export const ModalContent = styled.div`
  background-color: #fff;
  padding: 0rem 2rem 1rem 2rem;
  text-align: center;
  border: 0px;

  justify-content: center;
  vertical-align: middle;

  @media(max-width: 280px) {
    padding: 0rem 0rem 1rem 0rem;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;

  }
`;
